// PV Product Config with corrected per-tracker data matrix
// Per-tracker: maxPvKw, voltage range (minV-maxV), maxCurrent
// Group limits: maxPvKw for tracker groups
// Evaluation order: smallest system first

export const PV_SYSTEM_EVAL_ORDER = [
  "HS 6 PV",
  "HS 5 PV duo",
  "HS 6 PV duo",
  "HS 9 PV",
  "HS 9 PV duo",
  "HS 15 PV",
  "HS 15 PV duo",
];

export const pvProductConfig = [
  {
    family: "HS PV", model: "HS 6 PV",
    recommendedPvKw: 6.0, maxFeedInKw: 4.5, standardUsableKwh: 4.864,
    maxDischargeKw: 4.5, backupContinuousKva: 5.3, backupPeakKva30s: 9.0,
    mppts: [
      { id: "T1", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T2", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
    ],
    groupLimits: [{ trackerIds: ["T1", "T2"], maxPvKw: 7.2 }],
    preferredPrimaryTrackers: ["T1", "T2"],
  },
  {
    family: "HS PV", model: "HS 9 PV",
    recommendedPvKw: 6.9, maxFeedInKw: 5.8, standardUsableKwh: 9.73,
    maxDischargeKw: 7.2, backupContinuousKva: 9.0, backupPeakKva30s: 16.5,
    mppts: [
      { id: "T1", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T2", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
    ],
    groupLimits: [{ trackerIds: ["T1", "T2"], maxPvKw: 7.2 }],
    preferredPrimaryTrackers: ["T1", "T2"],
  },
  {
    family: "HS PV", model: "HS 15 PV",
    recommendedPvKw: 13.8, maxFeedInKw: 11.5, standardUsableKwh: 14.59,
    maxDischargeKw: 12.6, backupContinuousKva: 15.0, backupPeakKva30s: 27.0,
    mppts: [
      { id: "T1", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T2", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T3", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T4", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
    ],
    groupLimits: [{ trackerIds: ["T1", "T2", "T3", "T4"], maxPvKw: 14.4 }],
    preferredPrimaryTrackers: ["T1", "T2", "T3", "T4"],
  },
  {
    family: "HS PV duo", model: "HS 5 PV duo",
    recommendedPvKw: 9.6, maxFeedInKw: 8.0, standardUsableKwh: 4.864,
    maxDischargeKw: 4.2, backupContinuousKva: 5.0, backupPeakKva30s: 9.0,
    mppts: [
      { id: "T1", minV: 70, maxV: 245, maxA: 35, maxPvKw: 4.8 },
      { id: "T2", minV: 80, maxV: 550, maxA: 18, maxPvKw: 5.3 },
      { id: "T3", minV: 80, maxV: 550, maxA: 18, maxPvKw: 5.3 },
    ],
    groupLimits: [{ trackerIds: ["T2", "T3"], maxPvKw: 5.3 }],
    preferredPrimaryTrackers: ["T1"],
    secondaryTrackers: ["T2", "T3"],
    t1Preferences: {
      bestParallel: [[5,5],[4,4],[5,4]],
      bestSingle: [6, 5],
    },
  },
  {
    family: "HS PV duo", model: "HS 6 PV duo",
    recommendedPvKw: 10.2, maxFeedInKw: 8.5, standardUsableKwh: 4.864,
    maxDischargeKw: 4.5, backupContinuousKva: 5.3, backupPeakKva30s: 9.0,
    mppts: [
      { id: "T1", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T2", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T3", minV: 80, maxV: 550, maxA: 18, maxPvKw: 5.3 },
      { id: "T4", minV: 80, maxV: 550, maxA: 18, maxPvKw: 5.3 },
    ],
    groupLimits: [
      { trackerIds: ["T1", "T2"], maxPvKw: 7.2 },
      { trackerIds: ["T3", "T4"], maxPvKw: 5.3 },
    ],
    preferredPrimaryTrackers: ["T1", "T2"],
    secondaryTrackers: ["T3", "T4"],
  },
  {
    family: "HS PV duo", model: "HS 9 PV duo",
    recommendedPvKw: 16.6, maxFeedInKw: 13.8, standardUsableKwh: 9.73,
    maxDischargeKw: 7.2, backupContinuousKva: 9.0, backupPeakKva30s: 16.5,
    mppts: [
      { id: "T1", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T2", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T3", minV: 150, maxV: 1000, maxA: 20, maxPvKw: 14.0 },
      { id: "T4", minV: 150, maxV: 1000, maxA: 20, maxPvKw: 14.0 },
    ],
    groupLimits: [
      { trackerIds: ["T1", "T2"], maxPvKw: 7.2 },
      { trackerIds: ["T3", "T4"], maxPvKw: 14.0 },
    ],
    preferredPrimaryTrackers: ["T1", "T2"],
    secondaryTrackers: ["T3", "T4"],
  },
  {
    family: "HS PV duo", model: "HS 15 PV duo",
    recommendedPvKw: 31.8, maxFeedInKw: 26.5, standardUsableKwh: 14.59,
    maxDischargeKw: 12.6, backupContinuousKva: 15.0, backupPeakKva30s: 27.0,
    mppts: [
      { id: "T1", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T2", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T3", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T4", minV: 65, maxV: 450, maxA: 16, maxPvKw: 3.6 },
      { id: "T5", minV: 150, maxV: 1000, maxA: 20, maxPvKw: 18.0 },
      { id: "T6", minV: 150, maxV: 1000, maxA: 20, maxPvKw: 18.0 },
    ],
    groupLimits: [
      { trackerIds: ["T1", "T2", "T3", "T4"], maxPvKw: 14.4 },
      { trackerIds: ["T5", "T6"], maxPvKw: 18.0 },
    ],
    preferredPrimaryTrackers: ["T1", "T2", "T3", "T4"],
    secondaryTrackers: ["T5", "T6"],
  },
];

export const PV_DEFAULTS = {
  betaVocPercent: -0.30,
  minDesignTempC: -10,
  vmpEstimateFactor: 0.80,
  stcTempC: 25,
  maxStringsInConfigurator: 6,
  maxParallelPerMppt: 2,
  pvToleranceFilter: 0.20,
  pvYieldPerKwp: 950,
};

/**
 * Replace the default pvProductConfig + evaluation order with live values
 * coming from `/api/configurator/pv-systems`. Called once at app bootstrap.
 *
 * Defensive merge: kritische Tracker-Felder (mppts, groupLimits, …) und
 * positive Zahlen-Default-Werte (recommendedPvKw, maxFeedInKw, …) werden aus
 * den hartkodierten Defaults BEIBEHALTEN, wenn die Backend-Antwort sie leer/0
 * liefert. Verhindert, dass eine beschädigte DB die Sizing-Logik bricht.
 * Mutates the exported arrays in place so all sizing code picks up the new
 * values without re-import.
 */
export function overridePvProductConfig(newSystems, newOrder) {
  if (Array.isArray(newSystems) && newSystems.length) {
    // Lookup defaults by model — wir behalten den hartkodierten Eintrag als
    // Fallback für leere/0-Felder.
    const defaultByModel = Object.fromEntries(
      pvProductConfig.map(s => [s.model, s])
    );
    const LIST_FALLBACK_FIELDS = [
      'mppts', 'groupLimits', 'preferredPrimaryTrackers', 'secondaryTrackers',
    ];
    const NUMERIC_FALLBACK_FIELDS = [
      'recommendedPvKw', 'maxFeedInKw', 'standardUsableKwh',
      'maxDischargeKw', 'backupContinuousKva', 'backupPeakKva30s',
    ];
    const merged = newSystems.map(s => {
      const d = defaultByModel[s.model];
      if (!d) return s;  // unbekanntes Modell → Backend hat Vorrang
      const out = { ...s };
      for (const f of LIST_FALLBACK_FIELDS) {
        if ((!out[f] || (Array.isArray(out[f]) && out[f].length === 0)) && d[f]?.length) {
          out[f] = d[f];
        }
      }
      for (const f of NUMERIC_FALLBACK_FIELDS) {
        if ((!out[f] || out[f] === 0) && d[f] > 0) {
          out[f] = d[f];
        }
      }
      return out;
    });
    pvProductConfig.splice(0, pvProductConfig.length, ...merged);
  }
  if (Array.isArray(newOrder) && newOrder.length) {
    PV_SYSTEM_EVAL_ORDER.splice(0, PV_SYSTEM_EVAL_ORDER.length, ...newOrder);
  }
}
